import React, { Component } from "react";

import LoginInput from "../../../shared/items/contols/loginInput";

import styles from "./toRestorePassword.module.scss";

import { withRestore } from "../../../shared/containers/containerRestore";
import { states } from "../../../reducers/queriesStates";

class ToRestorePasswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { onHandleChangeStore, restore } = this.props;

    return (
      <React.Fragment>
        {restore.sendEmailDataState === states.READY ? (
          <div className={styles.sendMailCompleted}>Ссылка на восстановление пароля отправлена на {restore.restoreItems.email} </div>
        ) : null}

        <div className={styles.emailInput}>
          <LoginInput
            name="email"
            type="text"
            store={restore.restoreItems}
            handleChangeStore={onHandleChangeStore}
            placeholder="Email"
            errors={restore.errors}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default withRestore(ToRestorePasswordForm);
